// extracted by mini-css-extract-plugin
export default {"grid":"About_grid__mMSC7","map":"About_map__JWYQy"};